import { getTheme } from '@fluentui/react';

export const theme = getTheme();

export const comparedPickerSharedStyle = {
  '& .compared-date-range-picker .compared-date-range-picker-input .range-display': {
    verticalAlign: 'top',
  },
  '& .compared-date-range-picker .compared-date-range-picker-input .iconba-Calendar': {
    verticalAlign: 'top',
    top: '10px',
  },
};

export const pickerStyles = {
  picker: {
    display: 'inline-block',
    '& .icon-buttons': {
      paddingLeft: '6px',
      position: 'relative',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    '& button': {
      fontSize: '12px',
    },
    '& .next-button': {
    },
  },
  high: {
    height: '56px',
    '& button': {
      width: '28px',
      height: '56px',
    },
  },
  low: {
    height: '32px',
    '& button': {
      width: '28px',
      height: '28px',
    },
  },
  disabledColor: {
    backgroundColor: 'unset',
  },
  activeColor: {
    '&:active': {
      backgroundColor: 'unset',
      color: theme.palette.neutralPrimary,
    },
    color: theme.palette.neutralPrimary,
    '&:hover': {
      backgroundColor: theme.palette.neutralLighter,
      color: theme.palette.neutralPrimary,
    },
  },
};
